// extracted by mini-css-extract-plugin
export default {"root":"w8lXcP","icon":"XWnxXW"};